import type { ProductLogoSmallProps } from '../types';

/**
 * 小サイズのGAOperationCoreロゴアイコン
 */
export function ProductLogoSmallGAOperationCore({
  size = 20,
  color = '#25506B',
  ...props
}: ProductLogoSmallProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 480 480"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M270 36C283.255 36 294 46.7452 294 60V189H279C274.029 189 270 193.029 270 198V336H138C124.745 336 114 325.255 114 312V132C114 118.745 124.745 108 138 108H184V60C184 46.7452 194.745 36 208 36H270ZM158 216C153.582 216 150 219.582 150 224V244C150 248.418 153.582 252 158 252H178C182.418 252 186 248.418 186 244V224C186 219.582 182.418 216 178 216H158ZM230 216C225.582 216 222 219.582 222 224V244C222 248.418 225.582 252 230 252H250C254.418 252 258 248.418 258 244V224C258 219.582 254.418 216 250 216H230ZM158 144C153.582 144 150 147.582 150 152V172C150 176.418 153.582 180 158 180H178C182.418 180 186 176.418 186 172V152C186 147.582 182.418 144 178 144H158ZM230 144C225.582 144 222 147.582 222 152V172C222 176.418 225.582 180 230 180H250C254.418 180 258 176.418 258 172V152C258 147.582 254.418 144 250 144H230ZM230 72C225.582 72 222 75.5817 222 80V100C222 104.418 225.582 108 230 108H250C254.418 108 258 104.418 258 100V80C258 75.5817 254.418 72 250 72H230Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M399.515 219.515C397.264 217.264 394.212 216 391.029 216H312C305.373 216 300 221.373 300 228V420C300 426.627 305.373 432 312 432H432C438.627 432 444 426.627 444 420V268.971C444 265.788 442.736 262.736 440.485 260.485L399.515 219.515ZM336 356C336 351.582 339.582 348 344 348H400C404.418 348 408 351.582 408 356V364C408 368.418 404.418 372 400 372H344C339.582 372 336 368.418 336 364V356ZM344 276C339.582 276 336 279.582 336 284V292C336 296.418 339.582 300 344 300H400C404.418 300 408 296.418 408 292V284C408 279.582 404.418 276 400 276H344Z"
        fill={color}
      />
      <path
        d="M98.4668 288L60.9668 408H80.2471L147.705 364.825C153.493 361.121 160.592 360.075 167.202 361.953L279 393.714V444H44.6445C28.4533 444 16.9081 428.296 21.7373 412.842L66.7373 268.842C69.8684 258.822 79.1474 252 89.6445 252H98.4668V288Z"
        fill={color}
      />
    </svg>
  );
}
